const radii = {
  '2xl': '1rem',
  '3xl': '1.5rem',
  '4xl': '2.25rem',
  base: '0.25rem',
  full: '9999px',
  lg: '0.5rem',
  md: '0.375rem',
  none: '0',
  sm: '0.125rem',
  xl: '0.75rem',
};

/**
 * @deprecated
 * You can derive the Radii type from the DefaultChakraTheme
 *
 * type Radii = DefaultChakraTheme['radii']
 */
export type Radii = typeof radii;

export default radii;
